import { render, staticRenderFns } from "./cateAdd.vue?vue&type=template&id=fe8d9850&scoped=true"
import script from "./cateAdd.vue?vue&type=script&lang=js"
export * from "./cateAdd.vue?vue&type=script&lang=js"
import style0 from "./cateAdd.vue?vue&type=style&index=0&id=fe8d9850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8d9850",
  null
  
)

export default component.exports